import { render, staticRenderFns } from "./IconLetter.vue?vue&type=template&id=63a2854a"
import script from "./IconLetter.vue?vue&type=script&lang=ts"
export * from "./IconLetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports